package com.rylcart.cp.ui.api

import kotlinx.serialization.Serializable

@Serializable
data class Tenant(
    val id: String,
    val slug: String,
    val name: String,
    val host: String,
    val status: String,
    val deployTarget: String,
    val adminEmail: String,
    val plan: String,
    val cpuLimit: String? = null,
    val memoryLimitMb: Int? = null,
    val storageLimitGb: Int? = null,
    val createdAt: String,
    val updatedAt: String,
    val lastError: String? = null,
)

@Serializable
data class CreateTenantRequest(
    val slug: String,
    val name: String,
    val adminEmail: String,
    val host: String? = null,
    val plan: String = "starter",
    val deployTarget: String = "docker",
    val adminUsername: String? = null,
    val adminPassword: String? = null,
    // Resource caps — null fields fall back to the plan default server-side.
    val cpuLimit: String? = null,
    val memoryLimitMb: Int? = null,
    val storageLimitGb: Int? = null,
    // Remote VPS (deployTarget == "ssh") connection details. Authenticate with
    // either a private key or a password.
    val sshHost: String? = null,
    val sshUser: String? = null,
    val sshPort: Int? = null,
    val sshPrivateKey: String? = null,
    val sshPassword: String? = null,
)

@Serializable
data class CreateTenantResponse(val tenant: Tenant, val runId: Long)

@Serializable
data class RunIdResponse(val runId: Long)

@Serializable
data class ProvisioningRun(
    val id: Long,
    val tenantId: String,
    val action: String,
    val status: String,
    val exitCode: Int? = null,
    val startedAt: String,
    val finishedAt: String? = null,
    val logTail: String? = null,
)

@Serializable
data class LoginRequest(val email: String, val password: String)

@Serializable
data class RegisterRequest(val email: String, val password: String, val name: String? = null)

@Serializable
data class TokenResponse(val token: String, val expiresIn: Long = 60 * 60 * 12)

@Serializable
data class ErrorBody(val error: String)

@Serializable
data class SetupStatus(val needsSetup: Boolean)
